import { useContainer } from "#imports";
import { ref } from "vue";
import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import type CreditMapper from "~~/package/mapper/credit/CreditMapper";
import type { CreditHistoryModel } from "~~/package/mapper/credit/model/CreditHistoryModel";
import type { PageModel } from "~~/package/mapper/common/model/PageModel";
import type CreditPurchaseRequest from "~~/package/apis/credit/request/CreditPurchaseRequest";
import type { CreditPurchaseModel } from "~~/package/mapper/credit/model/CreditPurchaseModel";

const creditHistoryRefreshKey = ref(0);

export const triggerCreditHistoryRefresh = () => {
    creditHistoryRefreshKey.value++;
};

export const useCreditService = () => {
    const creditMapper = useContainer<CreditMapper>(DependencyInjectId.CreditMapper);

    const getCreditHistory = (page: number, size: number, creditTransactionType?: string[]): Promise<PageModel<CreditHistoryModel>> => {
        return creditMapper.getCreditHistory(page, size, creditTransactionType);
    }

    const purchaseCredits = (request: CreditPurchaseRequest): Promise<CreditPurchaseModel> => {
        return creditMapper.purchaseCredits(request);
    }

    return {
        getCreditHistory,
        purchaseCredits,
        creditHistoryRefreshKey,
    };
}
